import useStore from '../store';
import { BASE_URL } from '../constants/endpoints';

export const endpointManager = () => {
  const { getSummaryData } = useStore((state) => state);

  const getCustomerId = () => getSummaryData()?.customer?.externalId || '';
  const getCustomerExternalId = () => getSummaryData()?.accounts?.[0]?.accountExternalId || '';

  /** START Move Money Flow APIs */

  const getVendorsListUrl = () => `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/supplier`;

  /** ---------- ACH OUT */
  const getAchOutFeesUrl = (amount: number | string) =>
    `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/ach/out/fees?amount=${amount}`;
  const getAchOutLimitsUrl = () =>
    `${BASE_URL}/api/v2/user/${getCustomerId()}/${getCustomerExternalId()}/ach/out/limits`;
  const postAchOutReviewUrl = (billId?: string) => {
    if (billId) {
      return `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/${billId}/ach/out/billPay`;
    }
    return `${BASE_URL}/api/v3/user/${getCustomerId()}/${getCustomerExternalId()}/ach/out`;
  };
  /** ---------- END ACH OUT */

  /** ----------- START MAIL CHECK */
  const getMailCheckFeesUrl = () =>
    `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/mail/check/fees`;
  const getMailCheckLimitsUrl = () =>
    `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/mail/check/limits`;
  const postMailCheckReviewUrl = (billId?: string) => {
    if (billId) {
      return `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/${billId}/mail/check/billPay`;
    }
    return `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/mail/check`;
  };
  /** ----------- END MAIL CHECK */

  /** ------------ START WIRE OUT */
  const getWireFeesUrl = () =>
    `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/wire/out/fees?amount=1`;
  const getWireLimitsUrl = () =>
    `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/wire/out/limits`;
  const postWireOutReviewUrl = (billId?: string) => {
    if (billId) {
      return `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/${billId}/wire/out/billPay`;
    }
    return `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/wire/out`;
  };
  /** ------------ END WIRE OUT */

  /** ------------ START INTL WIRE OUT */
  const postInternationalWireOutReviewUrl = (billId?: string) => {
    if (billId) {
      return `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/${billId}/international/wire/out/billPay`;
    }
    return `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/international/wire/out`;
  };
  /** ------------ END INTL WIRE OUT */

  /** ------------ START MFA */
  const postMfaResendUrl = () =>
    `${BASE_URL}/api/v1/mfa/user/${getCustomerId()}/${getCustomerExternalId()}/resendMfaAction`;
  const postMfaVerifyForWireOutUrl = (billId?: string) =>
    (billId
      ? `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/${billId}/wire/out/billPay/mfaVerify`
      : `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/wire/out/mfaVerify`);
  const postMfaVerifyForInternationalWireOutUrl = (billId?: string) =>
    (billId
      ? `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/${billId}/international/wire/out/billPay/mfaVerify`
      : `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/international/wire/out/mfaVerify`);
  const postMfaVerifyForAchOutUrl = (billId?: string) =>
    (billId
      ? `${BASE_URL}/api/v1/user/${getCustomerId()}/${getCustomerExternalId()}/${billId}/ach/out/billPay/mfaVerify`
      : `${BASE_URL}/api/v2/user/${getCustomerId()}/${getCustomerExternalId()}/ach/out/mfaVerify`);
  /** ------------ END MFA */

  /** END Move Money Flow APIs */

  return {
    getAchOutFeesUrl,
    getAchOutLimitsUrl,
    postAchOutReviewUrl,
    getMailCheckFeesUrl,
    getMailCheckLimitsUrl,
    postMailCheckReviewUrl,
    getWireFeesUrl,
    getWireLimitsUrl,
    postWireOutReviewUrl,
    postMfaResendUrl,
    postMfaVerifyForWireOutUrl,
    postMfaVerifyForAchOutUrl,
    postMfaVerifyForInternationalWireOutUrl,
    postInternationalWireOutReviewUrl,
    getVendorsListUrl,
  };
};
